// extracted by mini-css-extract-plugin
module.exports = {"tick":"Tick-module--tick--kkLeN","alignRight":"Tick-module--alignRight--2TZbq","text":"Tick-module--text--26KiJ","value":"Tick-module--value--3kHvA"};